import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../lib/api';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/* [PATCH superadmin-ploscice v1] vsebina prenesena iz SuperadminPage.tsx (razdelilnik) */
export function SuperadminBazePage() {
  const [povprasevanja, setPovprasevanja] = useState<any[]>([]);
  const [kaziPov, setKaziPov] = useState(false); // [PATCH superadmin-baze-ui v1] povprasevanja privzeto skrita
  const [servisi, setServisi] = useState<any[]>([]);
  const [obrazec, setObrazec] = useState({ naziv: '', email_admina: '', telefon: '' });
  const [posiljam, setPosiljam] = useState(false);
  const [izbrisaneBaze, setIzbrisaneBaze] = useState<any[]>([]);
  const [baze, setBaze] = useState<any[]>([]);
  const [bazeIsci, setBazeIsci] = useState(''); // [PATCH superadmin-baze-ui v1] iskalnik po bazah
  const _bazeNorm = (s: any) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const bazeFilt = baze.filter((b: any) => !bazeIsci.trim() || _bazeNorm(`${b.naziv || ''} ${b.servis || ''}`).includes(_bazeNorm(bazeIsci.trim())));
  const [premikIzbor, setPremikIzbor] = useState<Record<string, string>>({});
  /* [PATCH kopija-na-test v1] gumb "Kopiraj na test" (samo, ko backend potrdi) */
  const [kopijaOmogocena, setKopijaOmogocena] = useState(false);
  const [kopijaTece, setKopijaTece] = useState<Record<string, boolean>>({});
  const [kopijaStatus, setKopijaStatus] = useState<Record<string, string>>({});

  /* [PATCH superadmin-upravljanje v1] uporabniki servisa (modal) */
  const [uporServis, setUporServis] = useState<any | null>(null);
  const [uporSeznam, setUporSeznam] = useState<any[]>([]);
  const [uporNalagam, setUporNalagam] = useState(false);
  const POV_PRAZEN = { email: '', vloga: 'racunovodja', vse_baze: true, lahko_odpira_baze: false, company_ids: [] as string[] };
  const [povObrazec, setPovObrazec] = useState({ ...POV_PRAZEN });
  const [povPosiljam, setPovPosiljam] = useState(false);

  /* [PATCH superadmin-upravljanje v2] urejanje uporabnika servisa */
  const [uporUrejan, setUporUrejan] = useState<any | null>(null);
  const URED_PRAZEN = { vloga: 'racunovodja', vse_baze: true, lahko_odpira_baze: false, aktiven: true, company_ids: [] as string[] };
  const [uredObrazec, setUredObrazec] = useState({ ...URED_PRAZEN });
  const [uredPosiljam, setUredPosiljam] = useState(false);

  const nalozi = () => {
    api.get('/superadmin/povprasevanja').then((r: any) => setPovprasevanja(r.data)).catch(() => {});
    api.get('/superadmin/servisi').then((r: any) => setServisi(r.data)).catch(() => {});
    api.get('/superadmin/izbrisane-baze').then((r: any) => setIzbrisaneBaze(r.data)).catch(() => {});
    api.get('/superadmin/baze').then((r: any) => setBaze(r.data)).catch(() => {});
    api.get('/superadmin/kopija-na-test/omogoceno').then((r: any) => setKopijaOmogocena(!!r?.data?.omogoceno)).catch(() => {}); /* [PATCH kopija-na-test v1] */
  };
  useEffect(nalozi, []);

  const nastaviStatus = async (id: string, status: string) => {
    try { await api.put('/superadmin/povprasevanja/' + id, { status }); nalozi(); }
    catch { toast.error('Napaka'); }
  };

  const ustvariServis = async () => {
    /* [PATCH superadmin-upravljanje v1] e-mail admina je opcijski */
    if (!obrazec.naziv.trim()) { toast.error('Vpišite naziv servisa'); return; }
    if (obrazec.email_admina.trim() && !obrazec.email_admina.includes('@')) {
      toast.error('E-mail admina ni veljaven'); return;
    }
    setPosiljam(true);
    try {
      const r: any = await api.post('/superadmin/servisi', obrazec);
      toast.success(r?.data?.povabilo_poslano
        ? 'Servis ustvarjen, povabilo poslano adminu'
        : 'Servis ustvarjen (brez povabila)');
      setObrazec({ naziv: '', email_admina: '', telefon: '' });
      nalozi();
    } catch (e: any) { toast.error(e?.response?.data?.detail || 'Napaka'); }
    finally { setPosiljam(false); }
  };

  const preklopiServis = async (s: any) => {
    try { await api.put('/superadmin/servisi/' + s.id, { aktiven: !s.aktiven }); nalozi(); }
    catch { toast.error('Napaka'); }
  };

  /* [PATCH superadmin-upravljanje v1] uporabniki servisa — nalaganje + povabilo */
  const odpriUporabnike = async (s: any) => {
    setUporServis(s); setUporSeznam([]); setUporNalagam(true);
    setPovObrazec({ ...POV_PRAZEN });
    setUporUrejan(null); /* [PATCH superadmin-upravljanje v2] */
    try {
      const r: any = await api.get('/superadmin/servisi/' + s.id + '/uporabniki');
      setUporSeznam(r.data.uporabniki || []);
    } catch { toast.error('Napaka pri nalaganju uporabnikov'); }
    finally { setUporNalagam(false); }
  };

  const povabiVServis = async () => {
    if (!uporServis) return;
    if (!povObrazec.email.includes('@')) { toast.error('Vpišite veljaven e-mail'); return; }
    if (!povObrazec.vse_baze && povObrazec.company_ids.length === 0) {
      toast.error('Izberite baze ali označite dostop do vseh baz'); return;
    }
    setPovPosiljam(true);
    try {
      await api.post('/superadmin/servisi/' + uporServis.id + '/povabi', povObrazec);
      toast.success('Povabilo poslano na ' + povObrazec.email);
      setPovObrazec({ ...POV_PRAZEN });
      odpriUporabnike(uporServis);
      nalozi();
    } catch (e: any) { toast.error(e?.response?.data?.detail || 'Napaka'); }
    finally { setPovPosiljam(false); }
  };

  /* [PATCH superadmin-upravljanje v2] urejanje uporabnika — odpiranje + shranjevanje;
     payload zrcali UporabnikiPage.shrani (company_ids: vse_baze ? [] : izbrane) */
  const odpriUrejanjeUpor = (u: any) => {
    setUporUrejan(u);
    setUredObrazec({ vloga: u.vloga, vse_baze: !!u.vse_baze, lahko_odpira_baze: !!u.lahko_odpira_baze,
                     aktiven: !!u.aktiven, company_ids: (u.baze || []) as string[] });
  };

  const shraniUporabnika = async () => {
    if (!uporServis || !uporUrejan) return;
    setUredPosiljam(true);
    try {
      await api.put('/superadmin/servisi/' + uporServis.id + '/uporabniki/' + uporUrejan.id, {
        vloga: uredObrazec.vloga, vse_baze: uredObrazec.vse_baze,
        lahko_odpira_baze: uredObrazec.lahko_odpira_baze,
        aktiven: uredObrazec.aktiven,
        company_ids: uredObrazec.vse_baze ? [] : uredObrazec.company_ids,
      });
      toast.success('Shranjeno');
      setUporUrejan(null);
      odpriUporabnike(uporServis);
      nalozi();
    } catch (e: any) { toast.error(e?.response?.data?.detail || 'Napaka'); }
    finally { setUredPosiljam(false); }
  };

  const obnoviBazo = async (b: any) => {
    if (!window.confirm(`Obnovim bazo "${b.name}"? Uporabniki bodo spet imeli dostop.`)) return;
    try { await api.post(`/superadmin/izbrisane-baze/${b.id}/obnovi`); toast.success('Baza obnovljena'); nalozi(); }
    catch { toast.error('Napaka pri obnovi'); }
  };

  const dokoncnoIzbrisi = async (b: any) => {
    if (!window.confirm(`DOKONČNO izbrišem bazo "${b.name}"?\n\nTrajno odstrani vse podatke (dokumente, partnerje, plačila, dnevnik). NEPOVRATNO.`)) return;
    try { await api.delete(`/superadmin/izbrisane-baze/${b.id}`); toast.success('Baza trajno izbrisana'); nalozi(); }
    catch (e: any) { toast.error(e?.response?.data?.detail || 'Napaka pri dokoncnem izbrisu'); }
  };

  const prestaviBazo = async (b: any) => {
    const ciljni = premikIzbor[b.id];
    if (!ciljni) { toast.error('Izberite ciljni servis'); return; }
    const ciljNaziv = servisi.find((s: any) => s.id === ciljni)?.naziv || ciljni;
    if (!window.confirm(`Prestavim bazo "${b.naziv}" iz "${b.servis}" v "${ciljNaziv}"?\n\nPrenese vse podatke baze. Uporabniki starega servisa izgubijo dostop.`)) return;
    try {
      const r: any = await api.post(`/superadmin/companies/${b.id}/premakni`, { ciljni_tenant_id: ciljni });
      toast.success(`Baza prestavljena (${r.data.skupaj_vrstic} vrstic)`);
      setPremikIzbor({ ...premikIzbor, [b.id]: '' });
      nalozi();
    } catch (e: any) { toast.error(e?.response?.data?.detail || 'Napaka pri premiku'); }
  };

  /* [PATCH kopija-na-test v1] PROD -> TEST kopija ene baze; status prek pollinga */
  const kopirajNaTest = async (b: any) => {
    if (!window.confirm(
      `Kopiram bazo "${b.naziv}" na TESTNO okolje?\n\n` +
      `Na testu se obstoječi podatki te baze (ujemanje po davčni številki) NEPOVRATNO ` +
      `prepišejo s produkcijskimi (dokumenti, knjižbe, partnerji, PDF datoteke). ` +
      `Produkcija se pri tem samo bere.`)) return;
    setKopijaTece((p) => ({ ...p, [b.id]: true }));
    setKopijaStatus((p) => ({ ...p, [b.id]: 'Zagon ...' }));
    try {
      const r: any = await api.post(`/superadmin/companies/${b.id}/kopija-na-test`, {});
      const taskId = r?.data?.task_id;
      if (!taskId) throw new Error('brez task_id');
      let poskusi = 0;
      const zanka = async () => {
        poskusi += 1;
        if (poskusi > 400) {
          setKopijaStatus((p) => ({ ...p, [b.id]: 'Status ni znan — preveri log workerja' }));
          setKopijaTece((p) => ({ ...p, [b.id]: false }));
          return;
        }
        try {
          const s: any = await api.get(`/superadmin/kopija-na-test/status/${taskId}`);
          const st = s?.data?.state;
          if (st === 'SUCCESS') {
            const rez = s?.data?.rezultat || {};
            setKopijaStatus((p) => ({ ...p, [b.id]: `Končano: ${rez.vrstic_skupaj ?? '?'} vrstic, ${rez.minio_objektov ?? '?'} datotek (${rez.minio_mb ?? '?'} MB)` }));
            setKopijaTece((p) => ({ ...p, [b.id]: false }));
            toast.success(`Kopija na test končana: ${b.naziv}`);
          } else if (st === 'FAILURE') {
            setKopijaStatus((p) => ({ ...p, [b.id]: `NAPAKA: ${s?.data?.napaka || 'neznano'}` }));
            setKopijaTece((p) => ({ ...p, [b.id]: false }));
            toast.error('Kopija na test ni uspela');
          } else {
            const meta = s?.data?.meta || {};
            setKopijaStatus((p) => ({ ...p, [b.id]: meta.faza ? `V teku: ${meta.faza}${meta.podrobnost ? ' — ' + meta.podrobnost : ''}` : 'V teku ...' }));
            window.setTimeout(zanka, 3000);
          }
        } catch { window.setTimeout(zanka, 5000); }
      };
      window.setTimeout(zanka, 1500);
    } catch (e: any) {
      setKopijaTece((p) => ({ ...p, [b.id]: false }));
      setKopijaStatus((p) => ({ ...p, [b.id]: '' }));
      toast.error(e?.response?.data?.detail || 'Napaka pri zagonu kopije');
    }
  };

  const polje = "px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white";

  return (
    <div className="p-6 space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Baze</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-1">Servisi, povpraševanja, premik in izbrisane baze</p>
        </div>
        <Link to="/superadmin"
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700">
          <ArrowLeft className="w-4 h-4" /> Nazaj
        </Link>
      </div>

      {izbrisaneBaze.length > 0 && (
        <section className="bg-white dark:bg-gray-800 rounded-xl shadow p-5 border-l-4 border-red-500">
          <h2 className="font-semibold text-red-700 dark:text-red-300 mb-3">
            Izbrisane baze ({izbrisaneBaze.length})
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                  <th className="py-2 pr-3">Baza</th>
                  <th className="py-2 pr-3">Servis</th>
                  <th className="py-2 pr-3">Izbrisano</th>
                  <th className="py-2 pr-3">Kdo</th>
                  <th className="py-2 pr-3 text-right">Dok.</th>
                  <th className="py-2 pr-3 text-right">Part.</th>
                  <th className="py-2 pr-3 text-right">Dejanje</th>
                </tr>
              </thead>
              <tbody>
                {izbrisaneBaze.map((b: any) => (
                  <tr key={b.id} className="border-b border-gray-100 dark:border-gray-800 last:border-0">
                    <td className="py-2 pr-3 font-medium text-gray-900 dark:text-white">{b.name}</td>
                    <td className="py-2 pr-3 text-gray-600 dark:text-gray-300">{b.servis}</td>
                    <td className="py-2 pr-3 text-gray-500 dark:text-gray-400 whitespace-nowrap">{b.deleted_at ? new Date(b.deleted_at).toLocaleString('sl-SI') : ''}</td>
                    <td className="py-2 pr-3 text-gray-500 dark:text-gray-400">{b.deleted_by || ''}</td>
                    <td className="py-2 pr-3 text-right tabular-nums">{b.st_dokumentov}</td>
                    <td className="py-2 pr-3 text-right tabular-nums">{b.st_partnerjev}</td>
                    <td className="py-2 pr-3 text-right whitespace-nowrap">
                      <button onClick={() => obnoviBazo(b)} className="px-2 py-1 rounded-md text-xs font-medium text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-950">Obnovi</button>
                      <button onClick={() => dokoncnoIzbrisi(b)} className="px-2 py-1 rounded-md text-xs font-medium text-red-600 hover:bg-red-50 dark:hover:bg-red-950 ml-1">Dokončno izbriši</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}


      {/* [PATCH superadmin-baze-ui v1] povprasevanja privzeto skrita */}
      {kaziPov ? (
      <section className="bg-white dark:bg-gray-800 rounded-xl shadow p-5">
        <div className="flex items-center justify-between mb-3"><h2 className="font-semibold text-gray-900 dark:text-white">Povpraševanja</h2><button onClick={() => setKaziPov(false)} className="text-xs text-gray-500 hover:text-blue-600">Skrij</button></div>
        <table className="w-full text-sm">
          <thead className="text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
            <tr><th className="px-3 py-2">Servis</th><th className="px-3 py-2">Kontakt</th>
                <th className="px-3 py-2">Sporočilo</th><th className="px-3 py-2">Status</th>
                <th className="px-3 py-2"></th></tr>
          </thead>
          <tbody>
            {povprasevanja.map((p) => (
              <tr key={p.id} className="border-b border-gray-100 dark:border-gray-700 align-top">
                <td className="px-3 py-2 font-medium text-gray-900 dark:text-white">{p.servis}</td>
                <td className="px-3 py-2 text-gray-600 dark:text-gray-300">{p.kontakt}<br />{p.email}<br />{p.telefon}</td>
                <td className="px-3 py-2 text-gray-600 dark:text-gray-300 max-w-xs">{p.sporocilo}</td>
                <td className="px-3 py-2">
                  <select value={p.status} onChange={(e) => nastaviStatus(p.id, e.target.value)}
                    className="rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white px-2 py-1">
                    <option value="novo">Novo</option>
                    <option value="obdelano">Obdelano</option>
                    <option value="zavrnjeno">Zavrnjeno</option>
                  </select>
                </td>
                <td className="px-3 py-2">
                  <button className="text-blue-600 hover:underline whitespace-nowrap"
                    onClick={() => setObrazec({ naziv: p.servis, email_admina: p.email, telefon: p.telefon || '' })}>
                    Odpri servis
                  </button>
                </td>
              </tr>
            ))}
            {povprasevanja.length === 0 && (
              <tr><td colSpan={5} className="px-3 py-4 text-gray-400">Ni povpraševanj</td></tr>
            )}
          </tbody>
        </table>
      </section>
      ) : (
        <div><button onClick={() => setKaziPov(true)} className="text-xs text-gray-500 hover:text-blue-600 underline">Pokaži povpraševanja ({povprasevanja.length})</button></div>
      )}

      <section className="bg-white dark:bg-gray-800 rounded-xl shadow p-5">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-3">{/* [PATCH superadmin-baze-ui v1] iskalnik */}
          <h2 className="font-semibold text-gray-900 dark:text-white">Baze — premik med servisi</h2>
          <div className="flex items-center gap-2">
            <input value={bazeIsci} onChange={(e) => setBazeIsci(e.target.value)} placeholder="Išči bazo ali servis…"
              className="w-72 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white px-2 py-1 text-sm" />
            {bazeIsci && <button onClick={() => setBazeIsci('')} className="text-xs text-gray-400 hover:text-gray-600">×</button>}
            <span className="text-xs text-gray-500 dark:text-gray-400 tabular-nums">{bazeFilt.length} / {baze.length}</span>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
              <tr><th className="px-3 py-2">Baza</th><th className="px-3 py-2">Trenutni servis</th>
                  <th className="px-3 py-2 text-right">Dok.</th><th className="px-3 py-2">Prestavi v</th>
                  <th className="px-3 py-2"></th></tr>
            </thead>
            <tbody>
              {bazeFilt.map((b: any) => (
                <tr key={b.id} className="border-b border-gray-100 dark:border-gray-700">
                  <td className="px-3 py-2 font-medium text-gray-900 dark:text-white">{b.naziv}</td>
                  <td className="px-3 py-2 text-gray-600 dark:text-gray-300">{b.servis}</td>
                  <td className="px-3 py-2 text-right tabular-nums">{b.st_dokumentov}</td>
                  <td className="px-3 py-2">
                    <select value={premikIzbor[b.id] || ''} onChange={(e) => setPremikIzbor({ ...premikIzbor, [b.id]: e.target.value })}
                      className="rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white px-2 py-1">
                      <option value="">— izberi servis —</option>
                      {servisi.filter((s: any) => s.id !== b.tenant_id).map((s: any) => (
                        <option key={s.id} value={s.id}>{s.naziv}</option>
                      ))}
                    </select>
                  </td>
                  <td className="px-3 py-2">
                    <button onClick={() => prestaviBazo(b)} disabled={!premikIzbor[b.id]}
                      className="px-3 py-1 rounded-md text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-40">
                      Prestavi
                    </button>
                    {/* [PATCH kopija-na-test v1] */}
                    {kopijaOmogocena && (
                      <button onClick={() => kopirajNaTest(b)} disabled={!!kopijaTece[b.id]}
                        className="ml-2 px-3 py-1 rounded-md text-xs font-medium text-white bg-amber-600 hover:bg-amber-700 disabled:opacity-40">
                        Kopiraj na test
                      </button>
                    )}
                    {kopijaStatus[b.id] && (
                      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400 max-w-[18rem]">{kopijaStatus[b.id]}</div>
                    )}
                  </td>
                </tr>
              ))}
              {baze.length === 0 && (<tr><td colSpan={5} className="px-3 py-4 text-gray-400">Ni baz</td></tr>)}
            </tbody>
          </table>
        </div>
      </section>

      <section className="bg-white dark:bg-gray-800 rounded-xl shadow p-5">
        <h2 className="font-semibold text-gray-900 dark:text-white mb-3">Računovodski servisi</h2>
        <table className="w-full text-sm">
          <thead className="text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
            <tr><th className="px-3 py-2">Naziv</th><th className="px-3 py-2">E-mail</th>
                <th className="px-3 py-2">Uporabniki</th><th className="px-3 py-2">Baze</th>
                <th className="px-3 py-2">Stanje</th><th className="px-3 py-2"></th></tr>
          </thead>
          <tbody>
            {servisi.map((s) => (
              <tr key={s.id} className="border-b border-gray-100 dark:border-gray-700">
                <td className="px-3 py-2 font-medium text-gray-900 dark:text-white">{s.naziv}</td>
                <td className="px-3 py-2 text-gray-600 dark:text-gray-300">{s.email}</td>
                <td className="px-3 py-2">{s.st_uporabnikov}</td>
                <td className="px-3 py-2">{s.st_baz}</td>
                <td className="px-3 py-2">
                  <span className={s.aktiven ? 'text-green-600' : 'text-red-500'}>
                    {s.aktiven ? 'Aktiven' : 'Suspendiran'}
                  </span>
                </td>
                <td className="px-3 py-2">
                  {/* [PATCH superadmin-upravljanje v1] */}
                  <button onClick={() => odpriUporabnike(s)} className="text-blue-600 hover:underline mr-3">
                    Uporabniki
                  </button>
                  <button onClick={() => preklopiServis(s)} className="text-blue-600 hover:underline">
                    {s.aktiven ? 'Suspendiraj' : 'Aktiviraj'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      {/* [PATCH superadmin-baze-ui v1] premaknjeno na dno */}
      <section className="bg-white dark:bg-gray-800 rounded-xl shadow p-5">
        <h2 className="font-semibold text-gray-900 dark:text-white mb-3">Nov računovodski servis</h2>
        <div className="flex flex-wrap gap-3">
          <input className={polje + ' flex-1 min-w-[200px]'} placeholder="Naziv servisa"
            value={obrazec.naziv} onChange={(e) => setObrazec({ ...obrazec, naziv: e.target.value })} />
          <input className={polje + ' flex-1 min-w-[200px]'} placeholder="E-mail admina (neobvezno)"
            value={obrazec.email_admina} onChange={(e) => setObrazec({ ...obrazec, email_admina: e.target.value })} />
          <input className={polje + ' w-36'} placeholder="Telefon"
            value={obrazec.telefon} onChange={(e) => setObrazec({ ...obrazec, telefon: e.target.value })} />
          <button disabled={posiljam} onClick={ustvariServis}
            className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium disabled:opacity-50">
            Ustvari servis
          </button>
        </div>
      </section>

      {/* [PATCH superadmin-upravljanje v1] modal: uporabniki servisa */}
      {uporServis && (
        <>
          <div className="fixed inset-0 z-40 bg-black/40" onClick={() => setUporServis(null)} />
          <div className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 w-[680px] max-w-[95vw] max-h-[85vh] overflow-y-auto bg-white dark:bg-gray-800 rounded-xl shadow-xl p-5">
            <div className="flex items-center justify-between mb-3">
              <h2 className="font-semibold text-gray-900 dark:text-white">
                Uporabniki — {uporServis.naziv}
              </h2>
              <button onClick={() => setUporServis(null)}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 text-lg leading-none">✕</button>
            </div>

            {uporNalagam && <div className="text-sm text-gray-400 py-2">Nalagam …</div>}
            {!uporNalagam && uporSeznam.length === 0 && (
              <div className="text-sm text-gray-400 py-2">Servis še nima uporabnikov.</div>
            )}
            {uporSeznam.length > 0 && (
              <table className="w-full text-sm mb-4">
                <thead className="text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                  <tr><th className="py-1.5 pr-3">E-mail</th><th className="py-1.5 pr-3">Ime</th>
                      <th className="py-1.5 pr-3">Vloga</th><th className="py-1.5 pr-3">Status</th>
                      <th className="py-1.5 pr-3">Vse baze</th><th className="py-1.5"></th></tr>
                </thead>
                <tbody>
                  {uporSeznam.map((u: any) => (
                    <tr key={u.id} className="border-b border-gray-100 dark:border-gray-700">
                      <td className="py-1.5 pr-3 text-gray-900 dark:text-white">{u.email}</td>
                      <td className="py-1.5 pr-3 text-gray-600 dark:text-gray-300">{u.ime}</td>
                      <td className="py-1.5 pr-3">{u.vloga}</td>
                      <td className="py-1.5 pr-3">{u.status}</td>
                      <td className="py-1.5 pr-3">{u.vse_baze ? 'da' : 'ne'}</td>
                      <td className="py-1.5">{/* [PATCH superadmin-upravljanje v2] */}
                        <button onClick={() => odpriUrejanjeUpor(u)}
                          className="text-blue-600 hover:underline">Uredi</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* [PATCH superadmin-upravljanje v2] uredi panel — zrcali polja UporabnikiPage */}
            {uporUrejan && (
              <div className="mb-4 border border-blue-200 dark:border-blue-900 rounded-lg p-3">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-medium text-gray-900 dark:text-white">Uredi: {uporUrejan.email}</h3>
                  <button onClick={() => setUporUrejan(null)}
                    className="text-sm text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">Prekliči</button>
                </div>
                <div className="flex flex-wrap items-center gap-4 mb-2 text-sm text-gray-700 dark:text-gray-300">
                  <select className={polje + ' w-44'} value={uredObrazec.vloga}
                    onChange={(e) => setUredObrazec({ ...uredObrazec, vloga: e.target.value })}>
                    <option value="admin">administrator</option>
                    <option value="racunovodja">računovodja</option>
                    <option value="stranka">stranka</option>
                  </select>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" checked={uredObrazec.aktiven}
                      onChange={(e) => setUredObrazec({ ...uredObrazec, aktiven: e.target.checked })} />
                    račun aktiven
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" checked={uredObrazec.vse_baze}
                      onChange={(e) => setUredObrazec({ ...uredObrazec, vse_baze: e.target.checked, company_ids: [] })} />
                    dostop do vseh baz servisa
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" checked={uredObrazec.lahko_odpira_baze}
                      onChange={(e) => setUredObrazec({ ...uredObrazec, lahko_odpira_baze: e.target.checked })} />
                    lahko odpira baze
                  </label>
                </div>
                {!uredObrazec.vse_baze && (
                  <div className="mb-3 max-h-40 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg p-2">
                    {baze.filter((b: any) => b.tenant_id === uporServis.id).length === 0 && (
                      <div className="text-xs text-gray-400">Servis nima baz.</div>
                    )}
                    {baze.filter((b: any) => b.tenant_id === uporServis.id).map((b: any) => (
                      <label key={b.id} className="flex items-center gap-2 text-sm py-0.5 text-gray-700 dark:text-gray-300">
                        <input type="checkbox" checked={uredObrazec.company_ids.includes(b.id)}
                          onChange={(e) => setUredObrazec({
                            ...uredObrazec,
                            company_ids: e.target.checked
                              ? [...uredObrazec.company_ids, b.id]
                              : uredObrazec.company_ids.filter((x) => x !== b.id),
                          })} />
                        {b.naziv}
                      </label>
                    ))}
                  </div>
                )}
                <button disabled={uredPosiljam} onClick={shraniUporabnika}
                  className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium disabled:opacity-50">
                  Shrani
                </button>
              </div>
            )}

            <h3 className="font-medium text-gray-900 dark:text-white mb-2">Povabi uporabnika v ta servis</h3>
            <div className="flex flex-wrap gap-3 mb-2">
              <input className={polje + ' flex-1 min-w-[220px]'} placeholder="E-mail"
                value={povObrazec.email} onChange={(e) => setPovObrazec({ ...povObrazec, email: e.target.value })} />
              <select className={polje + ' w-44'} value={povObrazec.vloga}
                onChange={(e) => setPovObrazec({ ...povObrazec, vloga: e.target.value })}>
                <option value="admin">administrator</option>
                <option value="racunovodja">računovodja</option>
                <option value="stranka">stranka</option>
              </select>
            </div>
            <div className="flex flex-wrap items-center gap-4 mb-3 text-sm text-gray-700 dark:text-gray-300">
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={povObrazec.vse_baze}
                  onChange={(e) => setPovObrazec({ ...povObrazec, vse_baze: e.target.checked, company_ids: [] })} />
                dostop do vseh baz servisa
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" checked={povObrazec.lahko_odpira_baze}
                  onChange={(e) => setPovObrazec({ ...povObrazec, lahko_odpira_baze: e.target.checked })} />
                lahko odpira baze
              </label>
            </div>
            {!povObrazec.vse_baze && (
              <div className="mb-3 max-h-40 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg p-2">
                {baze.filter((b: any) => b.tenant_id === uporServis.id).length === 0 && (
                  <div className="text-xs text-gray-400">Servis nima baz.</div>
                )}
                {baze.filter((b: any) => b.tenant_id === uporServis.id).map((b: any) => (
                  <label key={b.id} className="flex items-center gap-2 text-sm py-0.5 text-gray-700 dark:text-gray-300">
                    <input type="checkbox" checked={povObrazec.company_ids.includes(b.id)}
                      onChange={(e) => setPovObrazec({
                        ...povObrazec,
                        company_ids: e.target.checked
                          ? [...povObrazec.company_ids, b.id]
                          : povObrazec.company_ids.filter((x) => x !== b.id),
                      })} />
                    {b.naziv}
                  </label>
                ))}
              </div>
            )}
            <button disabled={povPosiljam} onClick={povabiVServis}
              className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium disabled:opacity-50">
              Pošlji povabilo
            </button>
          </div>
        </>
      )}
    </div>
  );
}
